import { useContext } from 'react'
import Button from '../button/Button'
import { IoCloseSharp } from 'react-icons/io5'
import { BiMenu } from 'react-icons/bi'
import { SideBarContext } from './provider'
import { useIconSize } from '@app/hooks'

const MenuToggle = () => {
    const { isSideBarOpen, toggleSidebar } = useContext(SideBarContext)
    const iconSize = useIconSize(20);
    return (
        <div className="pt-2" style={{
            display: 'flex',
            justifyContent:'center',
            paddingRight: isSideBarOpen ? '10px' : '0px',
        }}>
            <Button
                whileHoverProps={{ scale: 1.1 }}
                whileTapProps={{ scale: 0.9 }}
                onClick={toggleSidebar}
                style={{
                    alignItems: "center",
                    zIndex: 1100
                }}
            >
                {isSideBarOpen ? <IoCloseSharp size={iconSize} color="#fff" /> : <BiMenu size={iconSize} color="#fff" />}
            </Button>
        </div>)
}

export default MenuToggle